export const downloadFilePdf = (content: string, name: string, documentType?: string): void => {
	const isEdge: boolean = window.navigator.userAgent.indexOf('Edge') !== -1;
	const isIE: boolean = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge;
	const extension: string = contentType(name, documentType);

	if (!isEdge && !isIE) {
		const elem = window.document.createElement('a');
		elem.href = 'data:' + extension + ';base64,' + content;
		elem.download = name;
		document.body.appendChild(elem);
		elem.click();
		document.body.removeChild(elem);
	} else {
		const byteCharacters = atob(content);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], {
			type: extension,
		});
		navigator.msSaveOrOpenBlob(blob, name);
	}
};

const contentType = (fileName: string, documentType?: string): string => {
	const extension: string = documentType ? documentType : fileName.split('.')[1];

	if (extension === 'pdf') {
		return 'application/pdf';
	} else if (extension === 'png' || extension === 'jpg' || extension === 'jpeg') {
		return 'image/' + extension;
	} else if (extension === 'xls') {
		return 'application/vnd.ms-excel';
	} else if (extension === 'docx') {
		return 'application/octet-stream';
	}

	return '';
};
